<button
	[type]="type"
	(click)="onClick()"
	[disabled]="isDisabled"
	class="custom">
	<span>{{ buttonText }}</span>
</button>